import React from 'react'
import SupportContactFormPart from '../../react4xp/components/FormPages/SupportContactForm'
import { country_list } from '/lib/modules/util/constants'

function SupportContactForm({ breadcrumbs, title, intro, emailServiceUrl, productsCategoriesObj, privacyPolicyCheckboxRichText, recaptchaSiteKey, recaptchaValidationUrl, validationSummary}) {
	return (
		<SupportContactFormPart
			siteKey={recaptchaSiteKey}
			validationRecaptchaUrl={recaptchaValidationUrl}
			topInfos={{ title, intro }}
			form={{
				endpoint: emailServiceUrl,
				onSuccess: () => console.log('Sending email...'),
				onError: () => console.error('Error sending email')
			}}
			steps={{
				step1: {
					title: 'Choose the product(s) you need help with',
					options: productsCategoriesObj,
					errorMessage: 'Please choose one request type.'
				},
				step2: {
					title: 'Fill in your details',
					inputs: [
						{
							type: 'input',
							input: {
								type: 'text',
								id: 'first-name',
								name: 'First name',
								label: 'First name',
								required: true,
								errorMessages: {
									required: 'This field is required.'
								}
							}
						},
						{
							type: 'input',
							input: {
								type: 'text',
								id: 'last-name',
								name: 'Last name',
								label: 'Last name',
								required: true,
								errorMessages: {
									required: 'This field is required.'
								}
							}
						},
						{
							type: 'input',
							input: {
								type: 'text',
								id: 'title-position',
								name: 'Title / Position',
								label: 'Title / Position',
								required: true,
								errorMessages: {
									required: 'This field is required.'
								}
							}
						},
						{
							type: 'input',
							input: {
								type: 'text',
								id: 'company-name',
								name: 'Company name',
								label: 'Company name',
								required: true,
								errorMessages: {
									required: 'This field is required.'
								}
							}
						},
						{
							type: 'select',
							select: {
								id: 'country',
								name: 'Country',
								label: 'Country',
								defaultValue: 'Choose country',
								options: country_list,
								required: true,
								errorMessages: {
									required: 'This field is required.'
								}
							},
						},
						{
							type: 'input',
							input: {
								type: 'email',
								id: 'email',
								name: 'Email',
								label: 'Email',
								required: true,
								errorMessages: {
									required: 'This field is required.',
									invalidEmail: 'Invalid email format.'
								}
							}
						},
						{
							type: 'input',
							input: {
								type: 'tel',
								id: 'phone-number',
								name: 'Phone number',
								label: 'Phone number',
								required: true,
								errorMessages: {
									required: 'This field is required.'
								}
							}
						},
						{
							type: 'input',
							input: {
								type: 'text',
								id: 'reference-number',
								name: 'Support agreement reference number',
								label: 'Support agreement reference number',
								helperText: 'You can skip this step if you don’t have this information.'
							}
						},
						{
							type: 'textarea',
							textarea: {
								id: 'message',
								name: 'Message',
								label: 'Message',
								placeholder: 'Write your comment here...',
								required: true,
								errorMessages: {
									required: 'This field is required.'
								}
							}
						}
					]
				}
			}}
			privacyCheckbox={{
				name: 'terms',
				required: true,
				errorMessages: {
					required: 'This field is required.'
				},
				text: privacyPolicyCheckboxRichText
			}}
			submit={{
				validationMessage: validationSummary,
				label: 'Submit',
				successMessage: 'Your message has been submitted successfully.'
			}}
		/>
	)
}

export default SupportContactForm